module Meevo.Plugins.Transworld {
    'use strict';

    export interface ISectionParamsTransworld {
        sectionId: number;
        displayNameContentKey: string;
        template: string;
        isPrimarySection: boolean;
        handlesOwnCrud: boolean;
        baseEndpoint: string;
        sectionEndpoint: string;
        loggingService: Meevo.Components.Logging.ILoggingService;
        dataService: Meevo.Components.CommonClasses.ICommonDataService;
        context: TransworldContext;
        transworldService: Meevo.Plugins.Transworld.TransworldService;
        identityService: Meevo.Components.Common.IIdentityService;
        busyService: Meevo.Components.Busy.IBusyService;
        noun: Meevo.Model.NounEnum;
        sectionSecurityKey?: string;
    }

    export class TransworldBaseSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected transworldService: Meevo.Plugins.Transworld.TransworldService;
        protected context: TransworldContext;
        protected busyService: Meevo.Components.Busy.IBusyService;

        constructor(params: ISectionParamsTransworld) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey);

            this.transworldService = params.transworldService;
            this.context = params.context;
            this.busyService = params.busyService;
        }


        public activate(): void {
            this.isLoaded = true;
        }

        getResults(url, onPageLoad?) {
            return new Meevo.Components.BaseClasses.PagedResults(this.transworldService.dataService, url, onPageLoad, this.context);
        }
    }
}
